// @ts-nocheck
import { callApi, callApiPost, callApiPostUpload } from "../config/common";
import environment from "../config/environment";
import { withCodeLengthRequest } from "../utils/accessCode";

export const verifyEmail = async (data) => {
    let response = await callApiPost(environment.BASE_URL + "verify", data);
    return response;
}

export const sendCode = async (data) => {
    // Every request for a code asks for a 6-digit one (ACOP-164). Done here, once, so the sign-in screen and the
    // registration screen both carry it; a server that cannot issue 6 simply issues 4 and the box takes 4 to 6.
    let response = await callApiPost(environment.BASE_URL + "code/send", { ...data, data: withCodeLengthRequest(data.data) });
    return response;
}

export const preferences = async (data) => {
    let response = await callApiPost(environment.BASE_URL + "preferences/update", data);
    return response;
}

/** ACOP-157: the welcome survey of a brand-new person — create-only, works before any sign-in. */
export const registerPreferences = async (data) => {
    let response = await callApiPost(environment.BASE_URL + "preferences/register", data);
    return response;
}

export const verifyCode = async (data) => {
    let response = await callApiPost(environment.BASE_URL + "code/verify", data);
    return response;
}

export const user_details = async (data) => {
    let response = await callApi(environment.BASE_URL + "user/details", data);
    return response;
}

export const avsOsCapabilities = async () => {
    let response = await callApi(environment.BASE_URL + "copilot/avs-os/capabilities", {});
    return response;
}

/** ACOP-146 — the Knowledge Base page's glossary (per product) and paged search. GETs; AVS OS scopes them. */
export const avsOsKbGlossary = async (params = {}) => {
    let response = await callApi(environment.BASE_URL + "copilot/avs-os/kb/glossary", { ...params });
    return response;
}

export const avsOsKbSearch = async (params = {}) => {
    let response = await callApi(environment.BASE_URL + "copilot/avs-os/kb/search", { ...params });
    return response;
}

export const history = async (data) => {
    let response = await callApi(environment.BASE_URL + "copilot/history", data);
    return response;
}

export const feature_previews = async (data) => {
    let response = await callApi(environment.BASE_URL + "featurepreviews/getlist", data);
    return response;
}

export const update_interest = async (data) => {
    let response = await callApi(environment.BASE_URL + "featurepreviews/updateinterest", data);
    return response;
}

export const usage_stats = async (data) => {
    let response = await callApi(environment.BASE_URL + "email2quote/usagestats", data);
    return response;
}

export const required_list = async (data) => {
    let response = await callApi(environment.BASE_URL + "releasenotes/requiredlist", data);
    return response;
}

export const recent_list = async (data) => {
    let response = await callApi(environment.BASE_URL + "releasenotes/recentlist", data);
    return response;
}

export const release_notes_list = async (data) => {
    let response = await callApi(environment.BASE_URL + "releasenotes/getlist", data);
    return response;
}

export const upgrade_request = async (data) => {
    let response = await callApiPost(environment.BASE_URL + "updaterequest/create", data);
    return response;
}

export const select_account = async (data) => {
    // callApiPost posts param.data as the body, so the payload must be wrapped and stringified —
    // passing the object directly sends an empty body.
    let response = await callApiPost(environment.BASE_URL + "account/select", { data: JSON.stringify(data) });
    return response;
}

export const upgrade_request_list = async (data) => {
    let response = await callApi(environment.BASE_URL + "updaterequest/getlist", data);
    return response;
}

export const feature_request_required_list = async (data) => {
    let response = await callApi(environment.BASE_URL + "featurerequest/requiredlist", data);
    return response;
}

export const feature_request_get_list = async (data) => {
    let response = await callApi(environment.BASE_URL + "featurerequest/getlist", data);
    return response;
}

export const contact_admin = async (data) => {
    let response = await callApiPost(environment.BASE_URL + "featurerequest/contactadmin", data);
    return response;
}

export const feature_request_feedback = async (data) => {
    let response = await callApiPost(environment.BASE_URL + "featurerequest/feedback", data);
    return response;
}

export const vote = async (data) => {
    let response = await callApiPost(environment.BASE_URL + "featurerequest/vote", data);
    return response;
}

export const profile = async (data) => {
    let response = await callApi(environment.BASE_URL + "profile/getdata", data);
    return response;
}

export const updateSupportContact = async (data) => {
    let response = await callApiPost(environment.BASE_URL + "supportcontact/update", data);
    return response;
}

export const case_required_list = async (data) => {
    let response = await callApi(environment.BASE_URL + "case/requiredlist", data);
    return response;
}

export const case_list = async (data) => {
    let response = await callApi(environment.BASE_URL + "case/getlist", data);
    return response;
}

export const case_comments_list = async (data) => {
    let response = await callApi(environment.BASE_URL + "case/comments", data);
    return response;
}

export const case_comments_add = async (data) => {
    let response = await callApiPost(environment.BASE_URL + "case/add/comment", data);
    return response;
}

export const case_comments_add_reply = async (data) => {
    let response = await callApiPost(environment.BASE_URL + "case/comment/reply", data);
    return response;
}

export const case_upload_file = async (data, base64File) => {
    let url = environment.BASE_URL + "case/file/upload";
    let base64 = {file: base64File};
    url += '?data=' + encodeURIComponent(JSON.stringify(data));
    let response = await callApiPostUpload(url, base64);
    return response;
}

export const case_create = async (data) => {
    let response = await callApiPost(environment.BASE_URL + "case/create", data);
    return response;
}

export const case_close = async (data) => {
    let response = await callApiPost(environment.BASE_URL + "case/close", data);
    return response;
}

export const change_request_required_list = async (data) => {
    let response = await callApi(environment.BASE_URL + "changerequest/requiredlist", data);
    return response;
}

export const change_request_list = async (data) => {
    let response = await callApi(environment.BASE_URL + "changerequest/getlist", data);
    return response;
}

export const change_request_comments_list = async (data) => {
    let response = await callApi(environment.BASE_URL + "changerequest/comments", data);
    return response;
}

export const change_request_comments_add = async (data) => {
    let response = await callApiPost(environment.BASE_URL + "changerequest/add/comment", data);
    return response;
}

export const change_request_comments_add_reply = async (data) => {
    let response = await callApiPost(environment.BASE_URL + "changerequest/comment/reply", data);
    return response;
}

export const change_request_upload_file = async (data, base64File) => {
    let url = environment.BASE_URL + "changerequest/file/upload";
    let base64 = {file: base64File};
    url += '?data=' + encodeURIComponent(JSON.stringify(data));
    let response = await callApiPostUpload(url, base64);
    return response;
}

export const check_package_version = async (data) => {
    let response = await callApi(environment.BASE_URL + "versionstatus", data);
    return response;
}

export const request_help = async (data) => {
    let response = await callApiPost(environment.BASE_URL + "requesthelp", data);
    return response;
}

export const license_list = async (data) => {
    let response = await callApi(environment.BASE_URL + "licenses", data);
    return response;
}

export const license_adjustment = async (data, _base64File?) => {
    let response = await callApiPost(environment.BASE_URL + "adjustlicense", data);
    return response;
}

export const validateLogin = async (data) => {
    let response = await callApi(environment.BASE_URL + "validate-login", data);
    return response;
}

export const logout = async (data) => {
    let response = await callApiPost(environment.BASE_URL + "logout", data);
    return response;
}

export const product_list = async (data) => {
    let response = await callApi(environment.BASE_URL + "productcatalog", data);
    return response;
}

export const create_product_engagement = async (data) => {
    let response = await callApiPost(environment.BASE_URL + "productcatalog/engage", data);
    return response;
}
// ── Training (LMS learner side, served by AVS OS through copilot-api /apis/copilot/lms/*) ─────
// Ids travel in `data`, never in the path: roleMiddleware matches fixed paths only.

export const lmsOverview = async () => {
    return callApi(environment.BASE_URL + "copilot/lms/overview", {});
}

export const lmsPath = async (id) => {
    return callApi(environment.BASE_URL + "copilot/lms/path", { data: JSON.stringify({ id }) });
}

export const lmsCourse = async (id) => {
    return callApi(environment.BASE_URL + "copilot/lms/course", { data: JSON.stringify({ id }) });
}

export const lmsLesson = async (id) => {
    return callApi(environment.BASE_URL + "copilot/lms/lesson", { data: JSON.stringify({ id }) });
}

export const lmsLessonStudied = async (id) => {
    return callApiPost(environment.BASE_URL + "copilot/lms/lesson-studied", { data: JSON.stringify({ id }) });
}

export const lmsLessonCheck = async (id, answers) => {
    return callApiPost(environment.BASE_URL + "copilot/lms/lesson-check", { data: JSON.stringify({ id, answers }) });
}

export const lmsVideoProgress = async (id, percent) => {
    return callApiPost(environment.BASE_URL + "copilot/lms/video-progress", { data: JSON.stringify({ id, percent }) });
}

// Launch additions — contract: AVS OS docs/architecture/learning-copilot-api.md.

/** View All: published courses and paths this learner may see, each with an `enrolled` flag. */
export const lmsCatalog = async () => {
    return callApi(environment.BASE_URL + "copilot/lms/catalog", {});
}

export const lmsEnrollCourse = async (id) => {
    return callApiPost(environment.BASE_URL + "copilot/lms/course-enroll", { data: JSON.stringify({ id }) });
}

export const lmsEnrollPath = async (id) => {
    return callApiPost(environment.BASE_URL + "copilot/lms/path-enroll", { data: JSON.stringify({ id }) });
}

/** My transcript as data. The PDF/CSV and certificates download through utils/lmsFiles.ts. */
export const lmsTranscript = async () => {
    return callApi(environment.BASE_URL + "copilot/lms/transcript", {});
}

/** A customer's training admin: their own account's people and progress. */
export const lmsAdminProgress = async () => {
    return callApi(environment.BASE_URL + "copilot/lms/admin/progress", {});
}

export const lmsAdminAddPerson = async ({ email, firstName, lastName }) => {
    return callApiPost(environment.BASE_URL + "copilot/lms/admin/people", { data: JSON.stringify({ email, firstName, lastName }) });
}

export const lmsAdminSignupRequests = async () => {
    return callApi(environment.BASE_URL + "copilot/lms/admin/signup-requests", {});
}

/** decision: "approve" | "reject". */
export const lmsAdminDecideSignup = async (id, decision, reason) => {
    return callApiPost(environment.BASE_URL + "copilot/lms/admin/signup-decision", { data: JSON.stringify({ id, decision, reason }) });
}

/** Ask to join training. The email is the signed-in one; copilot-api ignores any other. */
export const lmsSignupRequest = async ({ firstName, lastName }) => {
    return callApiPost(environment.BASE_URL + "copilot/lms/signup-request", { data: JSON.stringify({ firstName, lastName }) });
}
